import { PgSubscriptMessagesComponent } from './pg-subscript-messages.component';
import { InjectionToken, Injectable } from '@angular/core';

export interface PgSubscriptRenderer {
  renderMessages(host: PgSubscriptMessagesComponent);
}

@Injectable()
export class DefaultSubscriptRenderer implements PgSubscriptRenderer {
  renderMessages(host: PgSubscriptMessagesComponent) {
    host.contentOutlet.createEmbeddedView(host.contentTemplate);
  }
}

export const PG_SUBSCRIPT_RENDERER_TOKEN = new InjectionToken<
  PgSubscriptRenderer
>('PgSubscriptRenderer');

export const PG_SUBSCRIPT_RENDERER_PROVIDER = {
  provide: PG_SUBSCRIPT_RENDERER_TOKEN,
  useClass: DefaultSubscriptRenderer,
};
